import React, { useState } from "react";
import { auth } from "../../firebase/config";
import { signInWithPhoneNumber } from "firebase/auth";

const OTP = () => {
  const [phone, setPhone] = useState("");
  const [otp, setOTP] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [message, setMessage] = useState("");
  const [token, setToken] = useState("");

  const sendOTP = async () => {
    if (!phone.startsWith("+")) {
      setMessage("Phone number must start with + country code (e.g., +91)");
      return;
    }

    try {
      // 🚀 Directly send OTP using Firebase Test Phone Numbers
      const result = await signInWithPhoneNumber(auth, phone);
      setConfirmationResult(result);
      setMessage("OTP sent successfully! (Using Firebase Test Number)");
    } catch (error) {
      console.error("OTP ERROR:", error);
      setMessage(error.message);
    }
  };

  const verifyOTP = async () => {
    if (!otp) {
      setMessage("Please enter OTP.");
      return;
    }

    try {
      const result = await confirmationResult.confirm(otp);
      const idToken = await result.user.getIdToken();
      setToken(idToken);

      setMessage("OTP Verified Successfully!");
    } catch (error) {
      console.error(error);
      setMessage("Invalid OTP. Try again.");
    }
  };

  return (
    <div style={styles.container}>
      <h2>📱 Firebase OTP Login</h2>

      <div style={styles.inputBox}>
        <label>Phone Number (with country code):</label>
        <input
          type="text"
          placeholder="+91XXXXXXXXXX"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          style={styles.input}
        />
      </div>

      <button onClick={sendOTP} style={styles.button}>
        Send OTP
      </button>

      {confirmationResult && (
        <>
          <div style={styles.inputBox}>
            <label>Enter OTP:</label>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOTP(e.target.value)}
              style={styles.input}
            />
          </div>

          <button onClick={verifyOTP} style={styles.buttonVerify}>
            Verify OTP
          </button>
        </>
      )}

      {message && <p style={styles.message}>{message}</p>}

      {token && (
        <div style={styles.tokenBox}>
          <h3>Generated Token:</h3>
          <textarea readOnly value={token} style={styles.textarea}></textarea>
        </div>
      )}
    </div>
  );
};

export default OTP;

// Styles stay the same
const styles = {
  container: {
    width: "350px",
    margin: "50px auto",
    padding: "20px",
    borderRadius: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontFamily: "Arial",
  },
  inputBox: {
    marginBottom: "15px",
    textAlign: "left",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginTop: "5px",
    borderRadius: "5px",
    border: "1px solid #aaa",
  },
  button: {
    width: "100%",
    padding: "10px",
    marginTop: "10px",
    background: "#007bff",
    border: "none",
    color: "#fff",
    borderRadius: "5px",
    cursor: "pointer",
  },
  buttonVerify: {
    width: "100%",
    padding: "10px",
    marginTop: "10px",
    background: "green",
    border: "none",
    color: "#fff",
    borderRadius: "5px",
    cursor: "pointer",
  },
  message: {
    marginTop: "15px",
    color: "blue",
  },
  tokenBox: {
    marginTop: "20px",
    textAlign: "left",
  },
  textarea: {
    width: "100%",
    height: "120px",
    padding: "10px",
  },
};
